// accessibility support for WebKit browsers
$('body').on('click', 'a.skipLink', function () {
  $($(this).attr('href')).attr('tabindex', '-1').focus();
  return true;
});
